import React from 'react';
import NavLinks from './NavLinks';
import MobileSidebar from '../layout/MobileSidebar';
import LogoLink from './LogoLink';

const TopNav = ({ categories }) => {
	return (
		<div className='flex gap-3 items-center bg-[#00BFFF] w-full justify-between'>
			<LogoLink />

			<div className='items-center justify-center hidden flex-1 md:flex'>
				<NavLinks categories={categories} />
			</div>
			<div className='flex md:hidden'>
				<MobileSidebar categories={categories} />
			</div>
		</div>
	);
};
export default TopNav;
